import { useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaGithub, FaInfoCircle } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useState, useEffect } from "react";
import Information from "./Information";


import RollCallImage1 from "../images/RollCall/rollcall_1.png";
import RollCallImage2 from "../images/RollCall/rollcall_2.png";
import RollCallImage3 from "../images/RollCall/rollcall_3.png";

import CampusConnectImage1 from "../images/CampusConnect/Screenshot 2026-02-01 233146.png";
import CampusConnectImage2 from "../images/CampusConnect/Screenshot 2026-02-01 233222.png";
import CampusConnectImage3 from "../images/CampusConnect/Screenshot 2026-02-01 233233.png";
import CampusConnectImage4 from "../images/CampusConnect/Screenshot 2026-02-01 233245.png";
import CampusConnectImage5 from "../images/CampusConnect/Screenshot 2026-02-01 233306.png";
import CampusConnectImage6 from "../images/CampusConnect/Screenshot 2026-02-01 233332.png";
import CampusConnectImage7 from "../images/CampusConnect/Screenshot 2026-02-01 233346.png";
import CampusConnectImage8 from "../images/CampusConnect/Screenshot 2026-02-01 233423.png";
import CampusConnectImage9 from "../images/CampusConnect/Screenshot 2026-02-01 233439.png";
import CampusConnectImage10 from "../images/CampusConnect/Screenshot 2026-02-01 233453.png";
import CampusConnectImage11 from "../images/CampusConnect/Screenshot 2026-02-01 233504.png";
import CampusConnectImage12 from "../images/CampusConnect/Screenshot 2026-02-01 233511.png";


import PGRPImage1 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.47.32 PM.jpeg";
import PGRPImage2 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.47.57 PM.jpeg";
import PGRPImage3 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.48.59 PM.jpeg";
import PGRPImage4 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.49.34 PM.jpeg";
import PGRPImage5 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.49.55 PM.jpeg";
import PGRPImage6 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.50.49 PM.jpeg";
import PGRPImage7 from "../images/PGRP/WhatsApp Image 2026-01-27 at 11.52.19 PM.jpeg";

// --- DATA ---
const projects = [
  {
    title: "Roll Call",
    description: "An easy-to-use attendance tracking system tailored for students",
    tech: ["React", "Appwrite",],
    github: "https://github.com/soumya16kp/Attendance-Management",
    live: "https://attendance-management-wheat.vercel.app/",
    accentColor: "pink",
    devNote: "This website is deployed on a free tier which may take an initial wake-up time. Please wait a moment for the server to respond.",
    images: [
      RollCallImage1,
      RollCallImage2,
      RollCallImage3
    ]
  },
  {
    title: "Campus Connect",
    description: "A one-stop hub for students to explore, join, and stay updated with campus clubs and activities. ",
    tech: ["Django", "PostgreSQL", "Bootstrap", "React"],
    github: "https://github.com/soumya16kp/College-management",
    live: "https://college-management-silk.vercel.app/",
    accentColor: "cyan",
    devNote: "This website is deployed on a free tier which may take an initial wake-up time. Please wait a moment for the server to respond.",
    images: [
      CampusConnectImage1,
      CampusConnectImage2,
      CampusConnectImage3,
      CampusConnectImage4,
      CampusConnectImage5,
      CampusConnectImage6,
      CampusConnectImage7,
      CampusConnectImage8,
      CampusConnectImage9,
      CampusConnectImage10,
      CampusConnectImage11,
      CampusConnectImage12
    ]
  },
  {
    title: "PGRP",
    description: "PGRP - Public Grievance Redressal Platform is an intelligent, location-aware civic grievance management platform  ",
    tech: ["React", "OpenStreetMap", "Django", "Rest-API", "PostgreSQL"],
    github: "https://github.com/soumya16kp/PGRP",
    live: "https://pgrp.vercel.app",
    accentColor: "purple",
    devNote: "This website is deployed on a free tier which may take an initial wake-up time. Please wait a moment for the server to respond.",
    images: [
      PGRPImage1,
      PGRPImage2,
      PGRPImage3,
      PGRPImage4,
      PGRPImage5,
      PGRPImage6,
      PGRPImage7
    ]
  },
  {
    title: "Temple Oasis ",
    description: "Empowering spiritual contributions through a modern, digital experience",
    tech: ["React", "Appwrite", "OpenStreetMap"],
    github: "https://github.com/soumya16kp/Temple-Oasis",
    live: "temple-oasis.vercel.app",
    accentColor: "pink", // Use simple names for mapping
    images: [
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      "https://images.unsplash.com/photo-1545239351-ef35f43d514b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80",
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
    ]
  },
];

// --- IMPORTANT: Helper object to map color names to actual Tailwind classes ---
// This prevents Tailwind from purging the dynamic classes during the build process.
const colorVariants = {
  pink: {
    bg: "bg-neon-pink",
    text: "text-neon-pink",
    border: "hover:border-neon-pink/40",
    tagBg: "bg-neon-pink/10",
    dot: "bg-neon-pink"
  },
  cyan: {
    bg: "bg-neon-cyan",
    text: "text-neon-cyan",
    border: "hover:border-neon-cyan/40",
    tagBg: "bg-neon-cyan/10",
    dot: "bg-neon-cyan"
  },
  purple: {
    bg: "bg-neon-purple",
    text: "text-neon-purple",
    border: "hover:border-neon-purple/40",
    tagBg: "bg-neon-purple/10",
    dot: "bg-neon-purple"
  }
};


// --- CARD COMPONENT ---
const ProjectCard = ({ project, index, handleInfoClick }) => {

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const colors = colorVariants[project.accentColor] || colorVariants.cyan; // Fallback to cyan

  // Image slideshow logic
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === project.images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3500); // Slightly slower interval for a more relaxed feel
    return () => clearInterval(interval);
  }, [project.images.length]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeInOut" }}
      viewport={{ once: true, amount: 0.2 }}
      className="group relative h-full "
    >
      {/* Neon glow effect on hover */}
      <div className={`absolute -inset-1.5 ${colors.bg} rounded-xl blur opacity-0 group-hover:opacity-25 transition-opacity duration-300 z-0`}></div>

      {/* Main card container with improved contrast */}
      <div className={`relative bg-slate-900/70 backdrop-blur-md border border-slate-800 rounded-xl h-full flex flex-col overflow-hidden ${colors.border} transition-colors duration-300 z-10`}>

        {/* Image slideshow */}
        <div className="relative h-48 sm:h-52 overflow-hidden">
          {project.images.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{
                opacity: index === currentImageIndex ? 1 : 0,
                scale: index === currentImageIndex ? 1 : 1.05
              }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="absolute inset-0"
            >
              <img
                src={image}
                alt={`${project.title} screenshot ${index + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              {/* Gradient overlay for better text visibility on dots */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            </motion.div>
          ))}
          {/* Image indicator dots */}
          <div className="absolute bottom-3 left-0 right-0 flex justify-center space-x-2 z-10">
            {project.images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentImageIndex ? `${colors.dot} w-4` : 'bg-slate-500 hover:bg-slate-400'}`}
                aria-label={`View image ${index + 1}`}
                aria-current={index === currentImageIndex ? "true" : "false"}
              />
            ))}
          </div>
        </div>

        {/* Text content section */}
        <div className="p-6 flex flex-col flex-grow">
          <h3 className={`text-xl font-bold mb-2 ${colors.text}`}>
            {project.title}
          </h3>
          <p className="text-slate-300 mb-4 text-sm leading-relaxed flex-grow">
            {project.description}
          </p>

          {/* Tech stack tags */}
          <div className="flex flex-wrap gap-2 mb-5">
            {project.tech.map((tech, i) => (
              <span
                key={i}
                className={`${colors.tagBg} ${colors.text} px-3 py-1 rounded-full text-xs font-medium`}
              >
                {tech}
              </span>
            ))}
          </div>

          {/* Links section */}
          <div className="mt-auto flex justify-between items-center pt-4 border-t border-slate-800">
            <div className="flex items-center space-x-4">
              <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} href={project.github} target="_blank" rel="noopener noreferrer" className={`text-slate-400 hover:${colors.text} text-xl transition-colors`} aria-label="GitHub">
                <FaGithub />
              </motion.a>
              <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }} target="_blank" rel="noopener noreferrer" className={`text-slate-400 hover:${colors.text} text-xl transition-colors`} aria-label="Live Demo" onClick={() => handleInfoClick(index)} >
                <FaInfoCircle />
              </motion.a>
            </div>
            <motion.a whileHover={{ x: 4 }} href={project.live} target="_blank" rel="noopener noreferrer" className={`flex items-center text-sm font-semibold ${colors.text}`}>
              View Project <FiArrowRight className="ml-1.5" />
            </motion.a>
          </div>
        </div>
      </div>

    </motion.div>
  );
};

// --- MAIN SECTION COMPONENT ---
export default function Projects() {
  const [showAll, setShowAll] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleInfoClick = (index) => {
    setSelectedIndex(index);
  };

  const toggleShow = () => {
    setShowAll(prev => !prev);
  }

  const itemsToDisplay = showAll ? projects : projects.slice(0, 3);

  const handleClose = () => setSelectedIndex(null);
  return (
    <section id="projects" className="relative text-white pt-24 pb-16 px-4 sm:px-6 overflow-hidden">

      <div className="max-w-7xl mx-auto relative z-10 ">
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 ">
            <span className="text-transparent  bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">
              My Projects
            </span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-neon-pink to-neon-purple mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid gap-8 sm:gap-10 md:grid-cols-2 lg:grid-cols-3">
          {itemsToDisplay.map((project, index) => (
            <ProjectCard
              key={index}
              project={project}
              index={index}
              handleInfoClick={handleInfoClick}
            />
          ))}
        </div>
      </div>

      <div className="flex justify-center">
        {projects.length > 3 && (
          <button
            onClick={toggleShow}
            className="flex items-center gap-2 px-5 py-2 mt-12 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 text-white font-medium shadow-md hover:bg-white/30 transition duration-300"
          >
            {showAll ? "Show Less" : "Show More"}
            <FaChevronDown
              className={`w-4 h-4 transition-transform duration-300 ${showAll ? "rotate-180" : "rotate-0"
                }`}
            />
          </button>
        )}
      </div>

      <AnimatePresence>
        {selectedIndex !== null && (
          <motion.div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleClose}
          >
            <motion.div
              className="w-full max-w-6xl max-h-[90vh]"
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 120, damping: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <Information
                project={projects[selectedIndex]}
                index={selectedIndex}
                onClose={handleClose}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      {/* Using <style> is fine, but for Next.js/Create React App, prefer global CSS files */}
      <style jsx global>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-20px) translateX(10px); }
        }
        @keyframes float-delay {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(15px) translateX(-10px); }
        }
        .animate-float { animation: float 10s ease-in-out infinite; }
        .animate-float-delay { animation: float-delay 10s ease-in-out infinite 2s; }
      `}</style>
    </section>
  );
}